import { AddCommentModalComponent } from './../../../shared/components/modals/add-comment/add-comment-modal.component';
import { ToastrService } from 'ngx-toastr';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { AfterViewInit, Component, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { BehaviorSubject, Observable } from 'rxjs';
import { SocieteModel } from 'src/app/shared/models/simple-types/societe.model';
import { BcModel } from 'src/app/shared/models/societe-linked/bc/bc.model';
import { BpComponentsService, DetailBpinfos } from '../bp-components.service';
import { BpModel } from 'src/app/shared/models/societe-linked/bp/bp.model';
import { BpService } from 'src/app/shared/services/bp/bp.service';
import { CycleBpModel } from 'src/app/shared/models/societe-linked/bp/cycle-bp.model';
import { BpValidationModel } from 'src/app/shared/dtos/bpValidationModel';

@Component({
  selector: 'app-validate-bp',
  templateUrl: './validate-bp.component.html',
  styleUrls: ['./validate-bp.component.scss']
})
export class ValidateBpComponent implements OnInit {
  bpForm: UntypedFormGroup;
  bp: BpModel = new BpModel();
  user: string;
  society: SocieteModel;
  observableBc = new BehaviorSubject<BcModel>(null);
  bcList: BcModel[];
  listOfBc: Observable<BcModel>;
  detailBpInfo: DetailBpinfos;
  bpLineHTs = 0;
  bpLineTVAs = 0;
  bpLineTTCs = 0;
  childHeight: number = 0;
  parentWidth: number = 0;

  constructor(private bpService: BpService,
              protected toastr: ToastrService,
              private router: Router,
              private dialog: MatDialog,
              private route: ActivatedRoute,
              private bpComponentsService: BpComponentsService,
              private toastrService: ToastrService) {
    this.route.params.subscribe((params: any) => {
      if (params.id === '0') {
        this.bpService.bpSubscriber.subscribe((bc: BpModel) => {
          if (bc !== null) {
            this.bp = Object.assign({}, bc);
          } else {
            this.toastrService.error('Erreur durant la récupération du bon de commande.', 'Erreur');
            this.router.navigate(['/']);
          }
        });
      } else {
        this.bpService.get(params.id).subscribe(bp => {
          this.bp = bp;
          this.detailBpInfo = new DetailBpinfos();

          this.bpForm = this.bpComponentsService.getValidateBpFormGroup(this.bp);
          if (this.bpForm) {
            this.bpLineTVAs = this.bpForm.get('tva').value;
            this.bpLineTTCs = this.bpForm.get('ttc').value;
            this.bpLineHTs = this.bpForm.get('ht').value;
          }
        }, (error) => {
          toastrService.error('Le bon de commade n\'existe pas');
          this.router.navigate(['/not-found']);
        });
      }

    });
  }

  ngOnInit(): void {
    this.getChildHeight();
    this.getParentWidth();
  }

  getSortedArrayByDate(): CycleBpModel[] {
    const arraySorted = this.bp.cycleBps.sort((a: CycleBpModel, b: CycleBpModel) => {
      return +new Date(b.dAction) - +new Date(a.dAction);
    });
    return arraySorted;
  }

  close(): void {
    this.router.navigate(['/list-bp/']);
  }

  print(): void {
    window.open('/assets/pdfs/bcpdf.pdf');
  }

  refus(): void {
    const dialogConfirmation = this.dialog.open(AddCommentModalComponent, {
      data: {
        title: 'Commentaire de refus',
        color: 'primary',
        icon_color: 'accent',
      }
    });
    dialogConfirmation.afterClosed().subscribe(res => {
      if (res !== '' && res) {
        const obj = new BpValidationModel();
        obj.bp = this.bp;
        obj.commentaire = res;
        this.bpComponentsService.refusBp(obj).subscribe(x => {
          this.router.navigate(['/list-bp/']);
        });
      }
      else if (res === '') {
        this.toastr.error('commentaire obligatoire');
      }

    });
  }
  bloquer() {
    this.bp.bBloque = true;
    this.bpService.update(this.bp.id, this.bp).subscribe(value => {
    });
  }
  debloquer() {
    this.bp.bBloque = false;
    this.bpService.update(this.bp.id, this.bp).subscribe(value => {
    });
  }
  validate(): void {
    const dialogConfirmation = this.dialog.open(AddCommentModalComponent, {
      data: {
        title: 'Commentaire de validation',
        color: 'primary',
        icon_color: 'accent',
      }
    });

    dialogConfirmation.afterClosed().subscribe(res => {
      if (res == '' || res) {
        const obj = new BpValidationModel();
        obj.bp = this.bp;
        obj.commentaire = res;
        this.bpComponentsService.validateBp(obj).subscribe(x => {
          this.router.navigate(['/list-bp/']);
        });
      }
    });
  }

  getChildHeight(): any {
    setTimeout(() => {
      const childHeight = document.querySelector('#heigthChild')?.clientHeight;
      if (childHeight && childHeight > 0) {
        this.childHeight = childHeight;
      }
    }, 200);
  }

  getParentWidth(): any {
    setTimeout(() => {
      const parentWidth = document.querySelector('#validate-bp-container')?.clientWidth;
      if (parentWidth && parentWidth > 0) {
        this.parentWidth = parentWidth;
      }
    }, 200);
  }
}
